<template>
  <div class="cache-setting">
    <div class="top-inputs">
      <!-- <loginInput
        :label="'开站端口'"
        :bottomTip="'可多选，“s”表示https端口'"
        tipStyle="color: #A1A7C4;margin-left: -12px;"
        inputStyle="width: 400px; height: 40px;"
        realInputStyle="width: 400px; height: 40px;"
        @changeInput="(e) => (cacheType = e)"
      /> -->

      <!-- <div class="btn-commit" @click="commitClick">
        {{ $t("product.commit") }}
      </div> -->
      <loginInput
        :label="'回源带宽'"
        :bottomTip="'填0为不限制'"
        tipStyle="color: #A1A7C4;"
        inputStyle="width: 400px; height: 40px;"
        realInputStyle="width: 400px; height: 40px;"
        @changeInput="(e) => (cacheDate = e)"
      />

      <div class="btn-commit" @click="commitClick2">
        {{ $t("product.commit") }}
      </div>
    </div>

    <div class="top-inputs" style="margin-top: 25px">
      <loginInput
        :label="'长连接'"
        :bottomTip="'该数值必须在10-120之间'"
        tipStyle="color: #A1A7C4;margin-left: -12px;"
        inputStyle="width: 400px; height: 40px;"
        realInputStyle="width: 400px; height: 40px;"
        @changeInput="(e) => (allRefresh = e)"
        :inputValue="allRefresh"
      />

      <div class="btn-commit" @click="commitClick3">
        {{ $t("product.commit") }}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import { configCN, configMainCn } from "@/service/requestRes";
export default {
  props: {
    domainHost: String,
    serverJson: String,
    type: String,
    subhost: String,
  },
  data() {
    return {
      switch: "",
      cacheType: "",
      cacheDate: "",
      allRefresh: "",
      userSelectsOptions: [
        {
          label: "1小时",
          value: "1",
        },
        {
          label: "十年",
          value: "2",
        },
      ],
    };
  },
  watch: {
    serverJson(val) {
      let serverJson1 = {};
      try {
        serverJson1 = val && JSON.parse(val);
        const { keepaliveTime } = serverJson1 || {};
        this.allRefresh = keepaliveTime;
      } catch (e) {}
    },
  },
  methods: {
    commitClick() {
      const cacheType = {
        func: "cacheType",
        host: this.domainHost,
        cache: {
          cacheType: this.cacheType,
        },
      };
      this.configCNMethod(cacheType);
    },

    commitClick2() {
      const arr = (this.cacheDate && this.cacheDate.split("/")) || [];
      alert(this.subhost); 
      const cacheType = {
        func: "cacheLimit",
        subhost: this.subhost,
        security: {
          cacheLimit: arr[0],
          cacheLimitTTL: arr[1],
        },
      };
      this.configCNMethod(cacheType);
    },

    commitClick3() {
      const keepaliveTime = {
        func: "keepaliveTime",
        host: this.domainHost,
        keepaliveTime: this.allRefresh,
      };
      this.configCNMethod(keepaliveTime);
    },
    allRefreshClick() {},

    switchChange2(e) {
      const closeBuffering = {
        func: "closeBuffering",
        host: this.domainHost,
        closeBuffering: e,
      };

      this.configCNMethod(closeBuffering);
    },
    switchChange(e) {
      const clearPath = {
        func: "clearPath",
        host: this.domainHost,
        security: {
          clearPath: e,
        },
      };

      this.configCNMethod(clearPath);
    },
    configCNMethod(obj) {
      if (this.type === "main") {
        configMainCn({
          ...obj,
          subhost: this.subhost,
          // subhost: this.domainHost,
        }).then((res) => {
          const { data, code, msg } = res || {};
          if (code === 1) {
            this.$message({
              message: "设置成功",
              type: "success",
            });
          } else {
            this.$message({
              message: msg,
              type: "error",
            });
          }
        });
      } else {
        configCN({
          ...obj,
          host: this.domainHost,
        }).then((res) => {
          const { data, code, msg } = res || {};
          if (code === 1) {
            this.$message({
              message: "设置成功",
              type: "success",
            });
          } else {
            this.$message({
              message: msg,
              type: "error",
            });
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cache-setting {
  padding-top: 20px;
  padding-bottom: 120px;
  .top-inputs {
    display: flex;
    position: relative;
  }
  .bottom-btn-group {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 50px;
    .btn-refresh {
      padding: 8px 30px;
      border: 1px solid #d7dbec;
      border-radius: 4px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #5a607f;
      margin-left: 27px;
      cursor: pointer;
    }
  }
}

.btn-commit {
  padding: 0 44px;
  height: 42px;
  line-height: 42px;
  background: #d9e4ff;
  border-radius: 4px;
  font-family: PingFangSC-Semibold;
  font-size: 14px;
  color: #1e5eff;
  cursor: pointer;
  margin-top: 23px;
}
</style>
